import { t as StyledSvgIcon } from "./SvgIcon.styles-A_BRPYMJ.js";
import * as React$1 from "react";
import { jsx } from "react/jsx-runtime";

//#region src/assets/icons/custom/plant.svg?react
const SvgPlant = (props) => /* @__PURE__ */ React$1.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	...props
}, /* @__PURE__ */ React$1.createElement("path", {
	fill: "currentColor",
	d: "M11 21v-7.975a7.9 7.9 0 0 1-3.075-.613A7.96 7.96 0 0 1 3.6 8.076Q3 6.601 3 5V3h2a7.9 7.9 0 0 1 3.05.612q1.475.613 2.6 1.738a7.6 7.6 0 0 1 1.287 1.7q.513.925.788 1.975.125-.176.275-.338t.325-.337a8 8 0 0 1 2.6-1.737A7.9 7.9 0 0 1 19 6h2v2a7.9 7.9 0 0 1-.613 3.075 8 8 0 0 1-1.737 2.6 7.8 7.8 0 0 1-2.587 1.725Q14.6 16 13 16v5zm0-10q0-1.2-.463-2.287a6.1 6.1 0 0 0-1.312-1.938 6.1 6.1 0 0 0-1.937-1.312A5.8 5.8 0 0 0 5 5q0 1.2.45 2.3t1.3 1.95 1.95 1.3T11 11m2 3a5.92 5.92 0 0 0 4.225-1.75 6 6 0 0 0 1.313-1.95Q19 9.2 19 8q-1.2 0-2.3.463a6 6 0 0 0-1.95 1.312A5.92 5.92 0 0 0 13 14"
}));

//#endregion
//#region src/icons/PlantIcon.tsx
function PlantIcon(props) {
	return /* @__PURE__ */ jsx(StyledSvgIcon, {
		component: SvgPlant,
		inheritViewBox: true,
		...props
	});
}

//#endregion
export { PlantIcon as t };
//# sourceMappingURL=PlantIcon-B0bRS9dC.js.map